import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {GoriSignatureScan} from '../../modules/gori-signature'

export default function GoriSignatureMethodSelectWrapper() {
  return (
    <PublicWrapper>
      <GoriSignatureScan />
    </PublicWrapper>
  )
}
